












import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { Action } from "vuex-class";

import { Locale } from "vue-i18n";

import { loadLanguage } from "@/i18n";

import { I18nStorageService } from "@/services/i18n-storage.service";

@Component
export default class I18nLocaleSelect extends Vue {
  @Action("auth/refreshToken") private refreshToken!: () => void;

  locale: Locale = I18nStorageService.locale;

  localeChangeRequested(event: Event) {
    const newLocale = (event.target as HTMLSelectElement).value;
    loadLanguage(newLocale);
    I18nStorageService.saveLocale(newLocale);
    this.refreshToken();
  }
}
